<template>
    <div class="tooltip1 my-2">
        <b-container>
            <b-row>
                <b-col cols="5">
                    <b-img src="https://s3-media0.fl.yelpcdn.com/bphoto/JkWblFghKi0DgZNUbvevcQ/90s.jpg"
                        height="90" 
                        rounded
                    />
                </b-col>
                <b-col>
                    <b-row>
                        <b-link class="font-weight-bold">
                            Revival
                        </b-link>
                    </b-row>
                    <b-row>
                        <Star
                            :rating="4.5"
                            :fontScale=1
                            :readOnly=true
                        />
                        <span class="text-muted">1031 reviews</span>
                    </b-row>
                    <b-row>
                        <span class="text-muted">Fastfood, Filipino</span>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.tooltip1 {
    background-color: white;
}
</style>

<script>
import Star from '../place/Star'

export default {
    components: {
        Star
    }
    
}
</script>